import { NgModule } from '@angular/core';
import { FuseSharedModule } from '@fuse/shared.module';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { AgGridModule } from '@ag-grid-community/angular';
import { PageTitleModule } from 'app/layout/components/page-title/page-title.module';
import { PayrollComponent } from 'app/main/payroll/payroll.component';
import { MaterialModule } from 'app/main/material.module';
import { MomentModule } from 'ngx-moment';
import {
  PayrollEffects,
  PayrollExtraEffects,
  PayrollRuleEffects,
} from './effects';
import { PayrollResolver } from './payroll.resolver';
import { EcranV1Component } from './views/ecran-v1/ecran-v1.component';
import { reducers } from './reducers';
import { EcranV2Component } from './views/ecran-v2/ecran-v2.component';
import { PayrollExtraComponent } from './views/payroll-extra/payroll-extra.component';
import { CancelConfirmButtonsModule } from '../shared/cancel-confirm-buttons/cancel-confirm-buttons.module';
import { PayrollDetailComponent } from './views/payroll-detail/payroll-detail.component';
import { PayrollSettingsComponent } from './views/payroll-settings/payroll-settings.component';
import { PayrollSyntheseComponent } from './views/payroll-synthese/payroll-synthese.component';
import { PayrollFilterComponent } from './views/payroll-filter/payroll-filter.component';
import { PayrollAnalyticsComponent } from './views/payroll-analytics/payroll-analytics.component';
import { PayrollAna2Component } from './views/payroll-ana2/payroll-ana2.component';
import { PayrollAna2PercentageComponent } from './views/payroll-ana2/payroll-ana2-percentage/payroll-ana2-percentage.component';
import { PayrollAna2CashComponent } from './views/payroll-ana2/payroll-ana2-cash/payroll-ana2-cash.component';

@NgModule({
  declarations: [
    PayrollComponent,
    EcranV1Component,
    EcranV2Component,
    PayrollExtraComponent,
    PayrollDetailComponent,
    PayrollSettingsComponent,
    PayrollSyntheseComponent,
    PayrollFilterComponent,
    PayrollAnalyticsComponent,
    PayrollAna2Component,

    PayrollAna2PercentageComponent,
    PayrollAna2CashComponent
  ],
  imports: [
    FuseSharedModule,
    MaterialModule,
    PageTitleModule,
    CancelConfirmButtonsModule,
    // AG Grid
    AgGridModule.withComponents([]),

    MomentModule,
    StoreModule.forFeature('payroll', reducers),
    EffectsModule.forFeature([
      PayrollEffects,
      PayrollExtraEffects,
      PayrollRuleEffects,
    ]),
  ],
  entryComponents: [PayrollDetailComponent],
  exports: [PayrollComponent],
  providers: [PayrollResolver],
})
export class PayrollModule {}
